export default "__VITE_ASSET__DyIVamJx__"